import { EvaluationForm } from "routes/EvaluationForm";
import { EvaluationRoute } from "routes/EvaluationRoute";
import { SurveyRoute } from "routes/SurveyRoute";
import { AssessmentRoute } from "routes/AssessmentRoute";
import { RequireAuth } from "features/auth/RequireAuth";
import { AssessmentForm } from "routes/AssessmentForm";
import { SurveyCode } from "routes/SurveyCode";
import { Home } from "routes/Home";
import { NotFound } from "routes/NotFound";
import { RouteObject } from "react-router";
import { SurveyForm } from "./SurveyForm";
import { AgentScoringRulesRoute } from "./AgentScoringRulesRoute";
import { AgentScoringRulePageRoute } from "./AgentScoringRulePageRoute";
import { RequireNoAuth } from "features/auth/RequireNoAuth";
import { TimeZoneProvider } from "features/timezone/useTimeZone";
import { EvaluationFormEvaluationFormTypeEnum } from "@genesys/cloud-frontend/models";

const routeConfig: RouteObject[] = [
    {
        path: "/evaluationForms/:evaluationFormId",
        element: (
            <RequireAuth>
                <EvaluationForm />
            </RequireAuth>
        ),
    },
    {
        path: "/evaluationForms/automated/:evaluationFormId",
        element: (
            <RequireAuth>
                <EvaluationForm
                    evaluationFormType={
                        EvaluationFormEvaluationFormTypeEnum.Automated
                    }
                />
            </RequireAuth>
        ),
    },
    {
        path: "/admin/interactions/:conversationId/evaluations/:evaluationId",
        element: (
            <RequireAuth>
                <TimeZoneProvider>
                    <EvaluationRoute context="admin" />
                </TimeZoneProvider>
            </RequireAuth>
        ),
    },
    {
        path: "/agent/interactions/:conversationId/evaluations/:evaluationId",
        element: (
            <RequireAuth>
                <TimeZoneProvider>
                    <EvaluationRoute context="agent" />
                </TimeZoneProvider>
            </RequireAuth>
        ),
    },
    {
        path: "/surveyForms/:surveyFormId",
        element: (
            <RequireAuth>
                <SurveyForm />
            </RequireAuth>
        ),
    },
    {
        path: "/surveys/:surveyId",
        element: (
            <RequireAuth>
                <TimeZoneProvider>
                    <SurveyRoute />
                </TimeZoneProvider>
            </RequireAuth>
        ),
    },
    {
        path: "/surveycodes/:code",
        element: (
            <RequireNoAuth>
                <SurveyCode />
            </RequireNoAuth>
        ),
    },
    {
        path: "/assessmentForms/:moduleStatus/:moduleId",
        element: (
            <RequireAuth>
                <AssessmentForm />
            </RequireAuth>
        ),
    },
    {
        path: "/assessmentForms/:moduleStatus/:moduleId/copy",
        element: (
            <RequireAuth>
                <AssessmentForm />
            </RequireAuth>
        ),
    },
    {
        path: "/assessmentForms/:moduleStatus/:moduleId/preview",
        element: (
            <RequireAuth>
                <AssessmentForm preview />
            </RequireAuth>
        ),
    },
    {
        path: "/assessments/:assignmentId",
        element: (
            <RequireAuth>
                <AssessmentRoute />
            </RequireAuth>
        ),
    },
    {
        path: "/programs/:programId/agentScoringRules",
        element: (
            <RequireAuth>
                <AgentScoringRulesRoute />
            </RequireAuth>
        ),
    },
    {
        // Create — no rule id, same pattern as PDUI `/agentScoringRule`.
        path: "/programs/:programId/agentScoringRule",
        element: (
            <RequireAuth>
                <AgentScoringRulePageRoute />
            </RequireAuth>
        ),
    },
    {
        path: "/programs/:programId/agentScoringRule/:ruleId",
        element: (
            <RequireAuth>
                <AgentScoringRulePageRoute />
            </RequireAuth>
        ),
    },
    {
        path: "/",
        element: <Home />,
    },
    {
        path: "*",
        element: <NotFound />,
    },
];

export default routeConfig;
